module.exports = __webpack_public_path__ + "img/der_02_coin.56aab5c5.png";